<template>
  <video
    :src="videoSrc"
    :type="type"
    :width="width"
    :autoplay="autoplay"
    :loop="loop"
    :muted="muted"
    :controls="controls"
    :height="height"
    :preload="preload"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getFullPathForPublicAssets } from '@/utils/url';

const props = defineProps({
  src: { type: String, required: true },
  type: { type: String, required: true },
  autoplay: { type: Boolean, required: false },
  loop: { type: Boolean, required: false },
  muted: { type: Boolean, required: false },
  controls: { type: Boolean, required: false },
  height: { type: String, required: false },
  width: { type: String, required: false },
  preload: { type: String, required: false },
});

// if prefixed with /video it's a relative asset
const videoSrc = computed(() => (props.src.startsWith('/video') ? getFullPathForPublicAssets(props.src) : props.src));
</script>

<style scoped lang="scss"></style>
